import React from 'react'
import styled from 'styled-components'

import { colors, rhythm, media } from '../utils/style-utils'
import { Subscribe } from 'unstated'
import AppContainer from './AppContainer'

const CardWrapper = styled.article`
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
`

const ImageWrapper = styled.div`
  padding: 0 3rem;
  background: linear-gradient(
    to bottom,
    transparent 53%,
    ${colors.mercury} 53%
  );
  img {
    display: block;
    width: 100%;
    height: auto;
    margin: 0 auto;
    max-width: 150px;

    ${media.desktop`
      max-width: none;
      max-width: 190px;      
    `};
  }
`

const Content = styled.div`
  background: ${colors.mercury};
  flex-grow: 1;
  padding: 1px ${rhythm(1)};
  padding-bottom: ${rhythm(1)};

  ${media.desktop`  
    padding: 1px ${rhythm(2)};
    padding-bottom: ${rhythm(3)};
  `};
`

const Title = styled.h2`
  font-weight: bold;
  font-size: 1.2rem;
  text-transform: uppercase;
  color: #000000;
  letter-spacing: 0.185em;
  text-align: center;
  line-height: 1.2;
  margin: ${rhythm(2)} 0;
`

const Description = styled.div`
  font-size: 1rem;
  line-height: 1.8;
  margin-top: ${rhythm()};
`

const SampleImage = styled.img`
  width: 100%;
  height: auto;
  display: block;

  max-height: 5rem;
`

const Button = styled.button`
  border: 0;
  display: inline-block;
  vertical-align: top;
  background: ${colors.black};
  color: ${colors.white};
  text-decoration: none;
  font-weight: bold;
  font-size: 13px;
  letter-spacing: 0.24em;
  line-height: 1.5;
  text-transform: uppercase;
  padding: 0.5em 1em;
  padding-right: 3em;
`

const Footer = styled.footer`
  text-align: left;
`

const Card = props => {
  const { title, description, imageSrc, sampleImageSrc } = props.data

  const { orderLabel } = props

  return (
    <Subscribe to={[AppContainer]}>
      {appContainer => (
        <CardWrapper className="c-card" key={title}>
          <ImageWrapper>
            <img src={imageSrc} alt={title} />
          </ImageWrapper>
          <Content>
            <Title>{title}</Title>
            <Description>{description}</Description>
          </Content>
          <SampleImage src={sampleImageSrc} />
          <Footer>
            <Button onClick={appContainer.openOrderModal}>{orderLabel}</Button>
          </Footer>
        </CardWrapper>
      )}
    </Subscribe>
  )
}

export default Card



// WEBPACK FOOTER //
// ./src/components/Card.js